import React from 'react';
import { Page, View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: '20mm 18mm 18mm 18mm',
    fontFamily: 'Helvetica',
  },
  // Header
  headerContainer: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontFamily: 'Helvetica-Bold',
    color: '#1e293b',
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 10,
    color: '#64748b',
    fontFamily: 'Helvetica',
    marginBottom: 10,
  },
  dividerLine: {
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    width: '100%',
  },
  // Table
  tableWrapper: {
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 2,
    overflow: 'hidden',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#151928',
  },
  headerCellStatus: {
    width: '26%',
    paddingVertical: 10,
    paddingHorizontal: 12,
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#ffffff',
    letterSpacing: 0.5,
  },
  headerCellDef: {
    width: '74%',
    paddingVertical: 10,
    paddingHorizontal: 14,
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#ffffff',
    letterSpacing: 0.5,
    borderLeftWidth: 1,
    borderLeftColor: '#2d3748',
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  statusCell: {
    width: '26%',
    paddingVertical: 12,
    paddingHorizontal: 12,
    justifyContent: 'center',
    alignItems: 'center',
    borderRightWidth: 1,
    borderRightColor: '#e2e8f0',
  },
  statusText: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
  },
  defCell: {
    width: '74%',
    paddingVertical: 12,
    paddingHorizontal: 14,
    fontSize: 9.5,
    color: '#334155',
    lineHeight: 1.45,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff',
  },
});

const STATUS_ROWS = [
  {
    label: 'Passed',
    color: '#166534',
    bg: '#eaf5ea',
    definition:
      'The test case was executed and the target behaved securely. The control works as intended and no issue was found.',
    hasBottomBorder: true,
  },
  {
    label: 'Failed',
    color: '#b91c1c',
    bg: '#fde8e8',
    definition:
      'The test case was executed and a vulnerability or weakness was identified. This item requires remediation.',
    hasBottomBorder: true,
  },
  {
    label: 'NA',
    color: '#475569',
    bg: '#f1f5f9',
    definition:
      'Not Applicable. The test case does not apply to this target or scope and was not tested. It is excluded from the pass/fail counts.',
    hasBottomBorder: false,
  },
];

const ChecklistStatusDefinitionsPage: React.FC = () => (
  <Page size="A4" style={styles.page}>
    {/* Header */}
    <View style={styles.headerContainer}>
      <Text style={styles.sectionTitle}>Status Definitions</Text>
      <Text style={styles.subtitle}>
        The following statuses are used against each test case in this report.
      </Text>
      <View style={styles.dividerLine} />
    </View>

    {/* Table */}
    <View style={styles.tableWrapper}>
      {/* Table header */}
      <View style={styles.tableHeader}>
        <Text style={styles.headerCellStatus}>STATUS</Text>
        <Text style={styles.headerCellDef}>DEFINITION</Text>
      </View>

      {/* Rows */}
      {STATUS_ROWS.map((row) => (
        <View key={row.label} style={styles.tableRow}>
          <View
            style={[
              styles.statusCell,
              { backgroundColor: row.bg },
              row.hasBottomBorder ? { borderBottomWidth: 1, borderBottomColor: '#e2e8f0' } : {},
            ]}
          >
            <Text style={[styles.statusText, { color: row.color }]}>
              {row.label}
            </Text>
          </View>
          <View
            style={[
              styles.defCell,
              row.hasBottomBorder ? { borderBottomWidth: 1, borderBottomColor: '#e2e8f0' } : {},
            ]}
          >
            <Text>{row.definition}</Text>
          </View>
        </View>
      ))}
    </View>
  </Page>
);

export default ChecklistStatusDefinitionsPage;
